import { Head, Link } from '@inertiajs/react'
import Form from './Form'

export default function New({ product }) {
  return (
    <>
      <Head title='New product' />

      <div className='mx-auto md:w-2/3 w-full px-8 pt-8'>
        <h1 className='font-bold text-4xl'>New product</h1>

        <Form
          product={product}
          onSubmit={(form) => {
            form.transform((data) => ({ product: data }));
            form.post('/dashboard/products');
          }}
          submitText='Create Product'
        />

        <Link
          href='/products'
          className='flex items-center justify-center bg-yellow-primary hover:bg-gray-600 hover:text-white w-fit text-gray-800 font-body font-bold mt-2 py-3 px-5 rounded-full shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
        >
          Back to products
        </Link>
      </div>
    </>
  );
}
